import React from 'react';
import { CheckCircle, Square, Pin } from 'lucide-react';

interface RoleChangeConfirmationProps {
  newRole: string;
}

const RoleChangeConfirmation = ({ newRole }: RoleChangeConfirmationProps) => {
  return (
    <div className="min-h-screen bg-gray-100 p-8 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        {/* Success Message */}
        <div className="text-center mb-8">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Role Changed Successfully!
          </h1>
          <p className="text-lg text-gray-700 capitalize">
            Your role has now been changed to {newRole}.
          </p>
        </div>

        {/* Instructions */}
        <div className="space-y-6">
          <div className="bg-blue-50 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-blue-900 mb-3">
              How to Access Traffic Lite
            </h2>
            
            <div className="space-y-4">
              {/* Step 1 */}
              <div className="flex items-start space-x-3">
                <div className="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                  1
                </div>
                <div>
                  <p className="text-blue-800 font-medium">Find the Chrome Extension</p>
                  <p className="text-blue-700 text-sm mt-1">
                    Look for the Traffic Lite icon in your Chrome toolbar (top-right corner of browser)
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start space-x-3">
                <div className="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                  2
                </div>
                <div>
                  <p className="text-blue-800 font-medium">If Not Visible, Check Puzzle Piece</p>
                  <p className="text-blue-700 text-sm mt-1">
                    Click the puzzle piece icon (🧩) in the toolbar to see all extensions
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start space-x-3">
                <div className="bg-blue-100 text-blue-800 rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                  3
                </div>
                <div>
                  <p className="text-blue-800 font-medium">Pin to Toolbar (Recommended)</p>
                  <p className="text-blue-700 text-sm mt-1">
                    Click the pin icon next to Traffic Lite to keep it visible in your toolbar
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Visual Icons */}
          <div className="flex justify-center space-x-8 text-gray-600">
            <div className="text-center">
              <Square className="w-8 h-8 mx-auto mb-2" />
              <p className="text-xs">Extensions Menu</p>
            </div>
            <div className="text-center">
              <Pin className="w-8 h-8 mx-auto mb-2" />
              <p className="text-xs">Pin Icon</p>
            </div>
          </div>

          {/* Note */}
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm text-gray-600">
              <strong>Note:</strong> You can now close this tab. The Traffic Lite extension will remember your role and show the appropriate interface when you click the extension icon.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleChangeConfirmation; 